import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import * as DecisionBaseModal from "components/pages/game/decision-modals/DecisionBaseModal";
import { GameContext } from "components/pages/game/GamePage";
import React, { useContext, useState } from "react";

export interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const Component: React.FC<Props> = ({ isOpen, onClose }) => {
  const { game } = useContext(GameContext);
  const [selectedColony, setSelectedColony] = useState<string>("");
  const [fundingOption, setFundingOption] = useState<number | null>(null);

  const renderButton = ({ text, onClick }: { text: string; onClick: () => void }) => {
    return (
      <Button
        key={text}
        variant="contained"
        color="primary"
        sx={{ m: 1, width: "250px", alignSelf: "center" }}
        onClick={() => onClick()}
      >
        {text}
      </Button>
    );
  };
  const renderColonySelectionModal = () => {
    return (
      <Dialog
        open={isOpen}
        onClose={() => {
          setSelectedColony("");
          setFundingOption(null);
          onClose();
        }}
        aria-labelledby="trade-with-colony-modal"
      >
        <DialogTitle id="trade-with-colony-modal">Trade with A Colony</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Select which Colony Tile you would like to trad with.
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {game.colonyTiles.map((colonyTile) =>
              renderButton({
                text: colonyTile.name,
                onClick: () => setSelectedColony(colonyTile.name),
              }),
            )}
          </Box>
        </DialogContent>
      </Dialog>
    );
  };

  const renderFundingSelectionModal = () => {
    return (
      <Dialog open={isOpen} onClose={onClose} aria-labelledby="trade-with-colony-modal">
        <DialogTitle id="trade-with-colony-modal">Trade with A Colony</DialogTitle>
        <DialogContent>
          <Typography variant="body1">Select how you want to pay.</Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {renderButton({
              text: "3 Power",
              onClick: () => setFundingOption(1),
            })}
            {renderButton({
              text: "3 Titanium",
              onClick: () => setFundingOption(2),
            })}
            {renderButton({
              text: "9 Money",
              onClick: () => setFundingOption(3),
            })}
          </Box>
        </DialogContent>
      </Dialog>
    );
  };

  const renderComponent = () => {
    if (selectedColony === "") {
      return renderColonySelectionModal();
    }
    if (!fundingOption) {
      return renderFundingSelectionModal();
    }
    return (
      <DecisionBaseModal.Component
        isOpen={isOpen}
        onClose={() => {
          setSelectedColony("");
          setFundingOption(null);
          onClose();
        }}
        content={
          <Typography variant="body1">
            Confirm you want to trade with <strong>{selectedColony}</strong>.
          </Typography>
        }
        ActionId="TRADE_COLONY"
        DecisionId="MAIN_ACTION"
        ActionData={{
          colonyTileName: selectedColony,
          option: fundingOption,
        }}
      />
    );
  };

  return renderComponent();
};

Component.displayName = "TradeWithColonyModal";
